import cn from 'classnames';
import { noop } from 'lodash';
import React from 'react';
import { MinusV2, PlusV2 } from 'src/shared/design-system/Icon';

interface MealPlanQuantityPickerProps {
  disabled?: boolean;
  editingDisabled?: boolean;
  onDecrement: () => void;
  onIncrement: () => void;
  outline?: boolean;
  value: number;
}

const largerTapTargetClasses =
  'before:content-[""] before:absolute before:w-[32px] before:h-[32px] before:cursor-pointer before:left-[-8px] relative';

export const MealPlanQuantityPicker: React.FC<MealPlanQuantityPickerProps> = ({
  disabled = false,
  editingDisabled = false,
  onDecrement,
  onIncrement,
  outline = true,
  value = 0,
}) => {
  const increment = editingDisabled ? noop : onIncrement;

  const decrement = editingDisabled ? noop : onDecrement;

  return (
    <div
      className={cn(`flex h-7 flex-row items-center justify-between rounded-lg border border-solid`, {
        'border-none': !outline,
        'gap-1 border-neutral-100 bg-raspberry px-2 text-white': value >= 1 && !editingDisabled,
        'border-white': value < 1 && !editingDisabled,
        'bg-raspberry': editingDisabled,
        'text-white': editingDisabled,
      })}>
      {value >= 1 && !editingDisabled && (
        <button
          className={cn(
            'm-0 flex items-center border-none p-0 font-bold leading-tight text-white',
            largerTapTargetClasses,
            {
              'bg-white text-raspberry': value < 1,
              'bg-raspberry text-white': value >= 1,
            }
          )}
          onClick={(e) => {
            e.stopPropagation();
            decrement();
          }}>
          <MinusV2 />
        </button>
      )}
      {(value >= 1 || editingDisabled) && (
        <span className={cn('mt-1 text-base', { 'px-2': editingDisabled })}>{value}</span>
      )}
      {!editingDisabled && (
        <button
          disabled={disabled}
          className={cn('m-0 flex items-center border-none p-0 font-bold leading-tight', largerTapTargetClasses, {
            ' bg-white text-neutral-200': disabled && value < 1,
            'bg-raspberry text-raspberry-hover': disabled && value >= 1,
            'bg-white text-raspberry': value < 1 && !disabled,
            'bg-raspberry text-white': value >= 1 && !disabled,
          })}
          onClick={(e) => {
            e.stopPropagation();
            increment();
          }}>
          <PlusV2 />
        </button>
      )}
    </div>
  );
};
